import React from "react";
import SkeletonElement from "./SkeletonElement";

export default function SkeletonCapaian() {
  return (
    <>
      <div className="h-[500px] skeletonWrapper rounded-2xl animate-pulse ">
        <SkeletonElement type="thumnailFull" />
      </div>
      <SkeletonElement type="title" />
    </>
  );
}
